import styled, { breakpoints } from 'src/styles/theme';
import { rem } from 'polished';
import { ModalSessionChangeTemplate } from './ModalSessionChangeTemplate';

export const ModalSessionChangeStyled = styled(ModalSessionChangeTemplate)`
    .description {
        margin-bottom: ${rem(35)};
    }

    .buttons {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: ${rem(20)};

        button {
            width: 100%;
        }

        @media (min-width: ${breakpoints.sm}px) {
            flex-direction: row;
            justify-content: center;
        }

        .section {
            margin-top: ${rem(10)};
            margin-bottom: ${rem(30)};
            display: flex;
            flex-direction: column;
            justify-content: center;
        }

        .name {
            display: block;
            text-align: center;
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
        }

        .image {
            width: ${rem(300)};
            padding-bottom: ${rem(30)};
            margin: 0 auto;
        }
    }
`;
